import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@material-ui/core';

interface CloseStateDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (newStateName: string) => void;
  currentStateId: number;
  assessmentId: number;
}

const CloseStateDialog: React.FC<CloseStateDialogProps> = ({
  open,
  onClose,
  onSave,
  currentStateId,
  assessmentId,
}) => {
  const [newStateName, setNewStateName] = useState('');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNewStateName(event.target.value);
  };

  const handleSave = () => {
    onSave(newStateName);
  };

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Close State</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="new-state-name"
          label="New State Name"
          type="text"
          fullWidth
          value={newStateName}
          onChange={handleChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
        <Button onClick={handleSave} color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CloseStateDialog;